"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InfrastructureOverview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const imageRef = useRef<HTMLDivElement>(null);
  const [imageScale, setImageScale] = useState(1.05);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;
      const rect = imageRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.top < viewportHeight && rect.bottom > 0) {
        const scrollProgress = Math.max(0, Math.min(1, 1 - rect.top / viewportHeight));
        const newScale = 1.05 - scrollProgress * 0.05;
        setImageScale(newScale);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="infrastructure-overview" className="min-h-screen bg-background text-foreground">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-0 min-h-screen items-center">
          {}
          

          {}
          <div ref={textRef} className={`py-12 lg:py-0 transition-all duration-[180ms] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="max-w-2xl">
              <h1 className="font-display font-bold text-[clamp(2.5rem,5vw,3.5rem)] leading-[1.2] tracking-tight mb-6">
                Energy Infrastructure Built for the Future
              </h1>

              <p className="text-lg leading-[1.6] text-muted-foreground mb-8">
                West Indian Digital operates mobile and immersion-cooled mining
                systems designed for energy efficiency and carbon impact
                reduction. Our infrastructure repurposes stranded and vented
                methane from oil and gas production to power digital asset
                operations.
              </p>

              <p className="text-lg leading-[1.6] text-muted-foreground mb-12">
                From the Caribbean, we deploy disciplined, institutional-grade
                infrastructure that prioritizes sustainability, operational
                excellence, and systematic risk management.
              </p>

              <Link to="/InfrastructurePage">
                <Button size="lg" className="bg-accent text-foreground-accent hover:bg-accent-hover active:bg-accent-active transition-all duration-[100ms] ease-[var(--ease-smooth)] hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
                  Explore Our Infrastructure
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}